import React, { Component } from 'react';
import PubSub from 'pubsub-js';

import HeaderMobileMenu from './HeaderMobileMenu';

//Images Assets
import LogoHeader from '../assets/header-logo.png';

// Componet's style
import '../css/Header.css';

class Header extends Component {
  constructor() {
    super();

    this.state= {
        mobile: false,
        lang: "pt"
    };

    this.locationTexts= {
      "inicio" : {"pt" : "Início", "es": "Home", "en": "Home"},
      "institucional" : {"pt" : "Institucional", "es": "Institucional", "en": "Institutional"}
    };
  }

  componentWillMount(){
    PubSub.subscribe('language.change', (msg, lang) => this.setState({lang}));
  }
  
  render() {
    let texts= this.locationTexts;  
    return (      
      <header id="header-desktop">
        <div id="container-logo">
            <img src={LogoHeader} id="header-logo" alt="Escolha Tecnologia" />
        </div>
        <nav id="header-menu">
            <a href="/" className="active">{texts["inicio"][this.state.lang]}</a>
            <a href="https://www.escolhatecnologia.com.br">{texts["institucional"][this.state.lang]}</a>
        </nav>
        <nav id="header-menu-mobile" className="isMobile">
            <span
              onClick={() => {this.headerMobileMenu.toggle()} }
            >
              <i className="fas fa-bars" ></i>
            </span>
        </nav>
        <HeaderMobileMenu ref={instance => { this.headerMobileMenu = instance; }}/>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/componentes/Header.js